/**
 * Created by xiaojielin on 17/1/11.
 */
export default function errorHandler (error) {
  console.log(error)
}



// WEBPACK FOOTER //
// ./src/error/errorHandler.js